import React from "react";
import Card from "../components/Card";
import Standard from "../components/common/Standard";
import Cyboryx from "../components/Cyboryx";
import Director from "../components/Director";
import Gold from "../components/Gold";
import Hero from "../components/Hero";
import IndustrialSectors from "../components/IndustrialSectors";
import OurGoals from "../components/OurGoals";
import Solution from "../components/Solution";

const Home = () => {
  return (
    <>
      <Hero />
      <Standard />
      <Director />
      <Solution />
      <Gold />
      <Card />
      <IndustrialSectors />
      <Cyboryx />
      <OurGoals />
    </>
  );
};

export default Home;
